import { NotifyHelper } from "../../../helpers/toast";
import { objCrmPhuHuynhDefine } from "../../action-types/crm-phuhuynh/ICrmPhuHuynhActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";
export const crmPhuHuynhActions = {
    // Tạo các action cơ bản cho PhuHuynh API
    ...generateActions(objCrmPhuHuynhDefine, "CRM_PHU_HUYNH"),

    // Xử lý lỗi khi load dữ liệu
    ...generateActionForKey(objCrmPhuHuynhDefine, "CRM_PHU_HUYNH",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),

    // Xử lý thành công khi tìm kiếm học sinh
    ...generateActionForKey(objCrmPhuHuynhDefine, "CRM_PHU_HUYNH",
        "SEARCH_SUCCESS", (m: any) => NotifyHelper.Success("Search completed successfully")),

    // Xử lý lỗi khi tìm kiếm PH
    ...generateActionForKey(objCrmPhuHuynhDefine, "CRM_PHU_HUYNH",
        "SEARCH_ERROR", (m: any) => NotifyHelper.Error(m)),

    // Xử lý thành công khi lấy thông tin chi tiết PH
    ...generateActionForKey(objCrmPhuHuynhDefine, "CRM_PHU_HUYNH",
        "GET_BY_ID_SUCCESS", (m: any) => NotifyHelper.Success("Parent details loaded successfully")),

    // Xử lý lỗi khi lấy thông tin chi tiết PH
    ...generateActionForKey(objCrmPhuHuynhDefine, "CRM_PHU_HUYNH",
        "GET_BY_ID_ERROR", (m: any) => NotifyHelper.Error(m)),
};
